export default __webpack_public_path__ + "images/d3436bfc591cf655f61150da149a7251-raffle.jpg";